/* eslint-disable @angular-eslint/prefer-inject */
import { PickListDataService } from '../infrastructure/pick-lists/pick-list.data.service';
import {
    PickListCreate,
    PickListDto,
    PickListRead,
    PickListSearchParams,
} from '../entities/pick-list.dto';
import { PickListStore } from '../infrastructure/pick-lists/pick-list.store';
import { inject, Injectable } from '@angular/core';
import { AbstractManageEntityFacade } from '@pf/shared-services';
import { PickListMapper } from '../infrastructure/pick-lists/pick-list.mapper';
import { BuildChangeTrackingFacadeFactory } from '@pf/shared/util-platform';
import { IQueryParams, SafeAny } from '@pf/shared-common';
import { Observable } from 'rxjs';
import { WarehouseFacade } from './warehouse.facade';
import { ResourceAuth } from '@control-tower/platform-wms';

@Injectable()
export class PickListFacade extends AbstractManageEntityFacade<
    PickListDto,
    PickListRead,
    PickListCreate,
    PickListSearchParams
> {
    private readonly warehouseFacade = inject(WarehouseFacade);
    nameField: keyof PickListDto = 'name';

    constructor(
        dataService: PickListDataService,
        store: PickListStore,
        mapper: PickListMapper
    ) {
        super(dataService, null, store, mapper);
    }

    override getDefaultSearchParams$(
        params: IQueryParams<PickListDto>
    ): Observable<IQueryParams<PickListDto>> {
        return this.warehouseFacade.addDefaultWarehouseParam(params);
    }

    override applyResourceAuth(body: PickListCreate): void {
        const locationId = this.warehouseFacade.active?.location?.id;
        body.resourceAuth = {
            locations: locationId ? [locationId] : [],
        } as ResourceAuth;
    }

    changeTrackingFactory = BuildChangeTrackingFacadeFactory(
        this.dataService,
        this.nameField as SafeAny
    );

    textSearchFilter(
        searchText: string
    ): Partial<Record<keyof PickListDto, string>> {
        return { name: searchText };
    }
}
